import { atom } from "jotai";
import { Practice } from "../models/Practice";

export const currentPracticeAtom = atom<Practice|undefined>(undefined);
